<template>
    <li class="item">
        <div class="left">
            <div class="day">{{sortNum}}</div>
            <div class="year-month">{{item.release_time.slice(0,7)}}</div>
        </div>
        <div class="right">
            <a class="title" target="_blank" :href="href">{{item.title}}</a>
            <a class="from" target="_blank" :href="href">{{item.sub_title}}</a>
        </div>
        <Divider/>
    </li>
</template>

<script>
    export default {
        data() {
            return {}
        },
        props: ['item','sortNum','href']
    }
</script>

<style lang="scss" scoped>
    .item {
        .day{
            width: 50px;
            height: 50px;
            text-align: center;
            line-height: 50px;
            border: 1px solid #8D8D8D;
            color: #8D8D8D;
            font-size: 32px;
            font-weight: 300;
            font-family:Heiti SC;
        }
        .year-month{
            margin-top: 6px;
            color: #5D5F61;
        }
        .left{
            display: inline-block;
            vertical-align: top;
            margin-right: 40px;
        }
        .right{
            display: inline-block;
            vertical-align: top;
            padding-top: 5px;
            a{
                display: block;
            }
            .title{
                max-width: 363px;
                color: #333333;
                font-size: 18px;
                margin-bottom: 17px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
            .from{
                max-width: 363px;
                color: $text-color;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
        }
    }
</style>